export var amountInputTheme = {
  baseStyle: _ref => {
    var {
      inputWidthInChars,
      descriptionAlignment
    } = _ref;
    return {
      field: {
        display: 'inline-flex',
        flexDirection: 'row',
        rowGap: 'none',
        alignItems: 'center',
        justifyContent: 'center'
      },
      inputElement: {
        textStyle: 'display2',
        paddingBottom: 'none',
        margin: 'none',
        border: 'none',
        width: "".concat(inputWidthInChars, "ch"),
        height: '1.2em',
        justifySelf: 'center',
        backgroundColor: 'transparent',
        _placeholder: {
          color: 'neutral.dark'
        },
        _focus: {
          border: 'none',
          outline: 'none'
        },
        '&[data-view-mode="true"]': {
          border: 'none',
          pointerEvents: 'none'
        }
      },
      inputDisplay: {
        textStyle: 'display2',
        marginRight: 'xs'
      },
      description: {
        display: 'flex',
        justifyContent: descriptionAlignment === 'start' ? 'start' : 'center'
      }
    };
  }
};
//# sourceMappingURL=AmountInput.theme.js.map